<script>
    import Time from "svelte-time";
    import ThumbnailComponent from "../Files/ThumbnailComponent.svelte";
    import Service from "../../utils/Service";

    export let config;
    export let listItemData;
    export let showDate = true;
    export let showAuthor = true;

    const service = new Service();

    function cutText(text, length = 100) {
        const decodedText = service.decodeHTML(text); // HTML-Entities dekodieren
        return decodedText.length > length ? decodedText.substring(0, length) + '...' : decodedText;
    }
</script>

<div class="card info-card">
    <div class="row g-0">
        <div class="col-md-4">
            <div class="image-container m-3">
                <ThumbnailComponent {config} contentID="{listItemData.id}" listView={true}
                                    classes="{{placeholder: 'thumbnail_background_list_view', thumbnail: 'file_thumbnail_list_view'}}"/>
            </div>
        </div>
        <div class="col-md-8">
            <div class="card-body">
                <div class="card-header">
                    <h3 class="card-title">{listItemData.titel}</h3>
                    <h6 class="m-0">
                        {#if showDate}
                            <Time timestamp="{listItemData.date}" format="DD.MM.YYYY"/>
                        {/if}
                        {#if showDate && showAuthor}
                            <span class="info-separator">|</span>
                        {/if}
                        {#if showAuthor}
                            {listItemData.author}
                        {/if}
                    </h6>
                </div>
                <article>
                    <p class="p-2 pt-3 card-text">{cutText(listItemData.text, 100)}</p>
                </article>
            </div>
        </div>
    </div>
</div>

<style>
    :global(.thumbnail_background_list_view) {
        min-height: 200px;
        background-color: rgba(232, 232, 232, 1) !important;
        border-radius: .25rem;
    }

    :global(.file_thumbnail_list_view) {
        width: 100%;
        border-radius: .25rem;
        overflow: hidden;
    }

    :global(.file_thumbnail_list_view img) {
        width: 100%;
        min-height: 200px;
        object-fit: cover;
    }

    .info-card {
        border: none;
        border-radius: 8px;
        margin-bottom: 28px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        transition: transform 0.2s;
        background-color: #f0f0f0; /* Helle Hintergrundfarbe */
        background-image: radial-gradient(circle, #eaeaea 1px, transparent 1px);
        background-size: 10px 10px; /* Größe der Rauschmuster */
    }

    .info-card:hover {
        transform: scale(1.02);
    }

    .image-container {
        border-radius: 8px;
        overflow: hidden;
        border: solid 4px #586a58;
    }

    .card-header {
        background-color: #586a58;
        color: white;
        padding: 10px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    .card-body {
        border-radius: 0 0 8px 8px;
        padding: 1rem;
    }

    .card-title {
        margin: 0;
        font-weight: bolder;
    }

    .card-text {
        font-size: 24px;
        line-height: 1.6;
        color: rgb(33, 37, 41);
        background-color: #fff;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    .info-separator {
        margin: 0 5px;
        color: white;
    }
</style>
